import React from 'react';
import { Segmented } from 'antd';
import { useTranslation } from 'react-i18next';
import { useHaptic } from '../../../hooks/useHaptic';

type TabValue = 'active' | 'history';

interface Props {
  value: TabValue;
  activeCount: number;
  historyCount: number;
  onChange: (tab: TabValue) => void;
  disabled?: boolean;
}

function isTabValue(v: string | number): v is TabValue {
  return v === 'active' || v === 'history';
}

export const SegmentControl: React.FC<Props> = ({
  value,
  activeCount,
  historyCount,
  onChange,
  disabled,
}) => {
  const { t } = useTranslation('customer');
  const haptic = useHaptic();

  const handleChange = (v: string | number) => {
    if (!isTabValue(v)) return;
    haptic.impactLight();
    onChange(v);
  };

  return (
    <Segmented
      block
      disabled={disabled}
      value={value}
      onChange={handleChange}
      options={[
        {
          label: activeCount > 0
            ? t('bookings.segment.activeCount', { count: activeCount })
            : t('bookings.segment.active'),
          value: 'active' as TabValue,
        },
        {
          label: historyCount > 0
            ? t('bookings.segment.historyCount', { count: historyCount })
            : t('bookings.segment.history'),
          value: 'history' as TabValue,
        },
      ]}
      style={{ margin: '0' }}
    />
  );
};
